import VendorsDataTable from "./VendorsDataTable";

export default VendorsDataTable;